import { NgModule } from '@angular/core';
import { InfiniteScrollDirective } from './infinite-scroll.directive';

/**
 * @deprecated Import InfiniteScrollDirective directly instead
 */
@NgModule({
    imports: [InfiniteScrollDirective],
    exports: [InfiniteScrollDirective]
})
export class InfiniteScrollModule {}
